import React from 'react';
import { useTranslate } from '../translations/useTranslate';
import { useTranslation } from 'react-i18next';
import './LanguageSelector.css';

/**
 * Language Selector Component
 * 
 * Add this to your Settings page or App header to let users change language
 * 
 * Usage:
 * import LanguageSelector from './components/LanguageSelector';
 * 
 * Then in your JSX:
 * <LanguageSelector />
 */

const LanguageSelector = () => {
  const { language, changeLanguage } = useTranslate();
  const { i18n } = useTranslation();
  const languages = [
    { code: 'en', name: 'English' },
    { code: 'te', name: 'తెలుగు' },
    { code: 'hi', name: 'हिंदी' }
  ];
  const handleLanguageChange = async (langCode) => {
    // Update both translation systems
    changeLanguage(langCode);
    await i18n.changeLanguage(langCode);

    // Store in both localStorage keys for compatibility
    localStorage.setItem('selectedLanguage', langCode);
    localStorage.setItem('appLanguage', langCode);
    // NO PAGE RELOAD - Let React re-render naturally
    // Components with language dependency will auto-update
  };
  return (
    <div className="language-selector">
      <label className="language-selector-label">
        Language / భాష / भाषा
      </label>
      <div className="language-buttons">
        {languages.map((lang) => (
          <button
            key={lang.code}
            className={`language-btn ${language === lang.code ? 'active' : ''}`}
            onClick={() => handleLanguageChange(lang.code)}
          >
            <span className="lang-name">{lang.name}</span>
          </button>
        ))}
      </div>
      <div className="current-language">
        Current: <strong>{languages.find(l => l.code === language)?.name || 'English'}</strong>
      </div>
    </div>
  );
};
export default LanguageSelector;
